var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"chat-cancel"},[_c('div',{staticClass:"chat-cancel__content"},[_c('p',{staticClass:"chat-cancel__text",domProps:{"innerHTML":_vm._s(_vm.cancelText)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }